import { useState } from "react";
import { CheckCircle2, Send } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import Reveal from "./Reveal";

export default function NewsletterBlock() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.post("/newsletter", { email: email.trim() });
      setDone(true);
      toast.success(data.message);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="max-w-[1440px] mx-auto px-5 lg:px-10 py-24">
      <Reveal>
        <div className="relative border border-white/10 bg-surface overflow-hidden">
          <div className="absolute -top-24 right-0 w-[420px] h-[420px] rounded-full bg-kinetic/10 blur-[120px] pointer-events-none" />
          <div className="relative px-6 py-14 lg:px-20 lg:py-20 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <div>
              <p className="text-xs font-mono uppercase tracking-[0.3em] text-kinetic mb-4">The Dispatch</p>
              <h2 className="font-display font-extrabold uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
                One email. <span className="font-serif italic normal-case text-ash">Every week.</span> Zero filler.
              </h2>
              <p className="text-ash mt-5 max-w-md leading-relaxed">
                The week's sharpest stories on style, sound, machines and ideas — plus the hottest community debates. Unsubscribe whenever, no hard feelings.
              </p>
            </div>
            <div>
              {done ? (
                <div data-testid="newsletter-success" className="flex items-center gap-4 border border-kinetic/40 bg-kinetic/5 p-6">
                  <CheckCircle2 className="text-kinetic shrink-0" size={28} />
                  <div>
                    <p className="font-display font-bold text-lg">You're in.</p>
                    <p className="text-ash text-sm">The next Dispatch lands in your inbox on Friday.</p>
                  </div>
                </div>
              ) : (
                <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3">
                  <input
                    data-testid="newsletter-email-input"
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="your@email.com"
                    className="flex-1 bg-obsidian border border-white/15 focus:border-kinetic/60 outline-none px-5 py-4 text-sm font-mono placeholder:text-ash/60 transition-colors duration-300"
                  />
                  <button
                    data-testid="newsletter-submit-button"
                    type="submit"
                    disabled={busy}
                    className="bg-kinetic text-obsidian font-mono text-xs uppercase tracking-[0.18em] font-medium px-7 py-4 flex items-center justify-center gap-2 hover:bg-porcelain transition-colors duration-300 disabled:opacity-50">
                    {busy ? "Joining…" : "Subscribe"} <Send size={14} />
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
